var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHeatRecovery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_795_262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.01578 9.5C5.80772 10.4122 5.02631 11.8645 5.02631 13.5002C5.02631 16.2615 7.2531 18.5 9.99999 18.5C12.7469 18.5 14.9737 16.2615 14.9737 13.5002C14.9737 11.8645 14.1922 10.4122 12.9842 9.5M6.92104 9.5V0.5H13.0789M13.0789 0.5V9.5M13.0789 0.5H14.9737M13.0789 3.34211H14.9737M13.0789 6.65789H14.9737M9.99999 11.5526C8.82275 11.5526 7.86841 12.4716 7.86841 13.6053C7.86841 14.7389 8.82275 15.6579 9.99999 15.6579C11.1773 15.6579 12.1316 14.7389 12.1316 13.6053C12.1316 12.4716 11.1773 11.5526 9.99999 11.5526ZM9.99999 11.5526V3.34211",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_795_262"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeatRecovery);
export default __webpack_public_path__ + "static/media/icon-heat-recovery.83b213a9c7085bfe4da9f06b2f220114.svg";
export { ForwardRef as ReactComponent };